export default {
  lang: {
    reset: 'Nollaa',
    search: 'Suodatin',
    expand: 'Laajenna',
    collapse: 'Varasto',
  },
};
